import Feedable from '@/global/dejaVue/feedable'

export default class EditModel extends Feedable {
    public userName = ''
    public prenom = ''
    public nom = ''
    public email = ''
    public phoneNumber: string | null = null

    constructor(options?: any) {
        super(options)
        this.feed(options)
    }

    public feed(options?: any) {
        if (options?.prenom) this.prenom = options.prenom
        if (options?.nom) this.nom = options.nom
        if (options?.email) this.email = options.email
        if (options?.phoneNumber) this.phoneNumber = options.phoneNumber
        if (options?.userName) this.userName = options.userName
        return this
    }
}
